<template>
  <div class="container">
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>

    <div class="custom-naming" v-else>
      <h3 class="title"><b>Student Leave Settings</b></h3>

      <div class="form-group">

        <!-- Approval Level Title -->
        <label class="subtitle"><u>Approval Level:</u></label>

        <!-- Level 1 -->
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio"
              v-model="student_leave_approval_level"
              value="1"
              @change="updateStudentLeaveSettings" />
            Single-level approval
          </label>
          <p class="status approved">✔ Approved by Advisor</p>
        </div>

        <!-- Level 2 -->
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio"
              v-model="student_leave_approval_level"
              value="2"
              @change="updateStudentLeaveSettings" />
            Two-level approval
          </label>
          <p class="status recommended">✔ Recommended by Advisor</p>
          <p class="status approved">✔ Approved by HOD</p>
        </div>

        <!-- Level 3 -->
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio"
              v-model="student_leave_approval_level"
              value="3"
              @change="updateStudentLeaveSettings" />
            Three-level approval
          </label>
          <p class="status forwarded">✔ Verified by Advisor</p>
          <p class="status recommended">✔ Recommended by HOD</p>
          <p class="status approved">✔ Approved by Admin</p>
        </div>

        <!-- NEW CHECKBOX (Default Unchecked) -->
        <div class="checkbox-group mt-3">
          <label class="checkbox-label">
            <input type="checkbox"
              v-model="mandatory_event_coordinator"
              @change="updateMandatoryEventCoordinator" />
            Set mandatory event coordinator recommendation for events specific duty leave
          </label>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  async created() {
    await this.getStudentLeaveSettings();
  },

  data() {
    return {
      fetchData: false,
      student_leave_approval_level: "1", // Default
      mandatory_event_coordinator: false, // NEW CHECKBOX
    };
  },

  methods: {
    // LOAD BOTH SETTINGS
    async getStudentLeaveSettings() {
      this.fetchData = true;

      /* ---- Load Approval Level ---- */
      const settingKey1 = "student_leave_approval_level";
      let baseURL = this.$store.getters.getAPIKey.institutionSettings;
      const url1 = baseURL.replace("setting_key", settingKey1);

      await axios.get(url1)
        .then((response) => {
          this.student_leave_approval_level = response.data ? response.data : "1";
        })
        .catch(() => {
          this.$toast.error("Failed to load student leave settings", {
            top: "top",
            duration: 6000,
          });
        });

      /* ---- mandatory_event_coordinator Setting ---- */
      const settingKey2 = "mandatory_event_coordinator";
      const url2 = baseURL.replace("setting_key", settingKey2);

      await axios.get(url2)
        .then((response) => {
          this.mandatory_event_coordinator = response.data == 1 ? true : false;
        })
        .catch(() => {});

      this.fetchData = false;
    },

    // UPDATE FIRST SETTING
    async updateStudentLeaveSettings() {
      const settingKey = "student_leave_approval_level";
      let baseURL = this.$store.getters.getAPIKey.institutionSettings;
      const url = baseURL.replace("setting_key", settingKey);

      await axios
        .post(url, {
          student_leave_approval_level: this.student_leave_approval_level
        })
        .then(() => {
          this.$toast.success("Student leave settings updated", {
            top: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error("Failed to update student leave settings", {
            top: "top",
            duration: 3000,
          });
        });
    },

    // UPDATE NEW CHECKBOX SETTING
    async updateMandatoryEventCoordinator() {
      const settingKey = "mandatory_event_coordinator";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);

      await axios
        .post(url, {
          mandatory_event_coordinator: this.mandatory_event_coordinator ? 1 : 0
        })
        .then(() => {
          this.$toast.success("Setting updated", {
            top: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error("Failed to update setting", {
            top: "top",
            duration: 3000,
          });
        });
    }

  }
};
</script>

<style scoped>
.container {
  max-width: 500px;
  margin: auto;
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  margin-bottom: 15px;
}

.subtitle {
  font-size: 16px;
  font-weight: bold;
  display: block;
  margin-bottom: 10px;
}

.radio-group {
  background: #ffffff;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.radio-label {
  display: block;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
}

.checkbox-group {
  background: #ffffff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.checkbox-label {
  font-size: 14px;
  font-weight: bold;
}

.status {
  font-size: 14px;
  font-weight: bold;
  margin-left: 20px;
}

.approved {
  color: green;
}

.recommended {
  color: blue;
}

.forwarded {
  color: purple;
}
</style>
